import { get } from "../GenericServices";

const ExportTimesheet = {
  downloadTimesheet: (queryString) => {
    return get(`export-timesheet/timesheet-detail?${queryString}`);
  },
  downloadCheckAdp: (queryString) => {
    return get(`export-timesheet/timesheet-adp-check?${queryString}`);
  },
  downloadSquaringTimesheet: (queryString) => {
    return get(`export-timesheet/timesheet-cost-detail?${queryString}`);
  },
};

export default ExportTimesheet;
